import React from "react";
import { withStyles } from "@material-ui/core";
import Icon from "../Icon";
import Typography from "../Typography";
import Button from "../Button";
import Dropzone from "react-dnd-dropzone";
import ImageCropper from "./imagecropper.js";
import InputFiles from "react-input-files";

const styles = theme => ({
  uploadMain: {
    textAlign: "center",
    marginTop: "150px"
  },
  icon: {},
  dragText: {
    marginTop: "21px"
  },
  buttonMain: {
    display: "flex",
    justifyContent: "center",
    marginTop: "42px"
  },
  button: {
    margin: "5px",
    [theme.breakpoints.down("sm")]: {
      margin: "2px"
    }
  },
  browseButton: {
    margin: "5px",
    [theme.breakpoints.down("sm")]: {
      margin: "2px"
    },
    position: "relative"
  },
  dimension: {
    marginTop: "17px",
    [theme.breakpoints.down("sm")]: {
      width: "350px"
    }
  },
  dragAndDrop: {
    border: "1px solid #DDD",
    borderStyle: "dashed"
  }
});

class Upload extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      crop: false
    };
    this.child = React.createRef();
  }

  handleReferenceMethod = () => {
    if (this.props.crop) this.child.current.handleCancel();
  };

  render() {
    const {
      classes,
      uploadIcon,
      fileTypeMsg,
      handleChange,
      handleCancel,
      crop,
      file,
      handleDrop,
      handleUpload,
      uploading,
      dimension_width,
      dimension_height
    } = this.props;
    return (
      <>
        {crop ? (

          <ImageCropper
            ref={this.child}
            handleCancel={handleCancel}
            file={file}
            handleUpload={handleUpload}
            dimension_width={dimension_width}
            dimension_height={dimension_height}
            uploading={uploading}
          />
        ) : (
            <div className={classes.uploadMain}>
              <Dropzone
                onDrop={handleDrop}
                render={({ canDrop, isOver }) => (
                  <div className={isOver ? `${classes.dragAndDrop}` : null}>
                    <div className={classes.icon}>
                      <Icon type={uploadIcon} size="xl" />
                    </div>

                    <div className={classes.dragText}>
                      <Typography type="body1" color="black">
                        Drag and drop an image here
                    </Typography>
                    </div>
                  </div>
                )}
              />
              <InputFiles onChange={handleChange}>
                <div className={classes.buttonMain}>
                  <Button
                    variant="secondary"
                    size="md"
                    state="active"
                    color="darkBlack"
                  >
                    Browse Files
                </Button>
                </div>
              </InputFiles>

              <div className={classes.dimension}>
                <Typography type="body2" color="deepGrey">
                  {fileTypeMsg}
                </Typography>
              </div>
            </div>
          )}
      </>
    );
  }
}

export default withStyles(styles)(Upload);
